import { render, staticRenderFns } from "./SummaryReview.vue?vue&type=template&id=26982425"
import script from "./SummaryReview.vue?vue&type=script&lang=js"
export * from "./SummaryReview.vue?vue&type=script&lang=js"
import style0 from "./SummaryReview.vue?vue&type=style&index=0&id=26982425&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports